import React, { useState } from 'react';
import { cdnDomain } from '../../utilities/config';

const NortonImage = `${cdnDomain}/static/images/norton-icon.png`;
const typingCompleteInterval = 2000;

export default (props) => {
  const {
    value,
    placeholder,
    errorMessage,
    isValid,
    onBlur,
    name,
    hideRecording,
    type,
    readOnly,
    note,
    idName,
    maxLength,
    showLengthCounter,
    emoji,
    label,
    isVerified,
    disabled,
    isMultiLine = false,
    inputMode,
    allowAutoComplete = false,
    customEventName,
    isDarkMode = false,
    isRounded = true,
    defaultBackground = false,
    sensitiveData,
    isNightAddress = false,
    isIncidentYear = false,
  } = props;

  const [isTyping, setIsTyping] = useState(false);
  const [listenForErrors, setListenForErrors] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(0);

  const onChange = (e) => {
    setIsTyping(true);
    if(type === 'number') {
      const { value } = e.currentTarget;
      const numberValue = Number(value);
      if (isNaN(numberValue)) {
        return;
      }
    }

    props.onChange && props.onChange(e);
    
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(setTimeout(() => {
      setIsTyping(false);
      props.onEndTyping && props.onEndTyping(e);
    }, typingCompleteInterval));
  };

  const commonProps = {
    className: `
      ${isMultiLine ? 'multi-line-input text-input--is-rounded' : 'text-input text-input--is-rounded'} 
      ${emoji ? 'text-input-with--emoji' : ''}
      ${sensitiveData ? 'sensitive-data-field' : ''}
      ${disabled || readOnly ? 'text-input--is-disabled' : ''}
      ${isIncidentYear ? 'text-input--is-incident-year' : ''}
    `,
    name,
    value: value ?? '',
    onBlur: () => {
      onBlur && onBlur();
      setListenForErrors(true);
    },
    placeholder,
    id: idName ?? '',
    maxLength,
    onChange: isMultiLine ? undefined : (event) => {
      onChange(event);
      setListenForErrors(true);
      customEventName && smartlook('track', customEventName, {})
    },
    onInput: isMultiLine ? (event) => {
      onChange(event);
      setListenForErrors(true);
    } : undefined,
    disabled,
    readOnly,
  };

  if (note) {
    return (
      <div className="text-input-wrapper">
        <textarea
          className={'text-input text-input-is-notes--rounded'}
          placeholder="Extra Notes..."
          rows="4"
          onInput={onChange}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
    );
  }

  const renderInputField = () => {
    if (isMultiLine) {
      return <textarea {...commonProps} />;
    }
    return <input {...commonProps} type='text' pattern={type === 'number' ? '[0-9]*' : undefined} inputMode={type === 'number' ? 'numeric' : undefined} autoComplete={allowAutoComplete ? 'on' : 'off'}/>;
  };

  return (
    <>
      <div className={`text-input-parent-wrapper ${isVerified ? 'text-input-parent-wrapper--is-verified' : ''}`}>
        <div className='text-input-label-wrapper'>
          {label && <p className='text-input-label'>{label}</p>}
          {isVerified ? <img className='norton-icon' src={NortonImage} alt='' /> : ''}
        </div>
        <div
          className={
            `text-input-wrapper
          ${hideRecording ? 'sessioncamhidetext' : ''}
          ${emoji ? 'text-input-wrapper-with--emoji' : ''}
          ${isValid ? 'text-input-wrapper--is-valid' : listenForErrors && errorMessage ? 'text-input-wrapper--is-invalid' : ''}
          ${!isValid && isNightAddress ? 'text-input-wrapper--is-invalid-address' : ''}
          ${disabled || readOnly ? 'text-input-wrapper--is-disabled' : ''}
          ${isIncidentYear ? 'text-input-wrapper--is-incident-year' : ''}`
          }>
          {emoji && <img src={emoji} className="input-emoji input-emoji--is-margin-bottom" />}

          {/* Conditionally render the input or textarea */}
          {renderInputField()}
          {maxLength && showLengthCounter ?
            <p className='max-length-counter'>
              <span style={{ color: value && value.length === maxLength ? 'red' : 'inherit' }}>
                {value && value.length || 0}
              </span> / 2000
            </p>

            : <div />
          }

        </div>
      </div>
      {(listenForErrors && !isNightAddress) && <p className="form-input-error-message">{isValid ? '' : errorMessage}</p>}
    </>
  );
}
